import { createDefault } from "../utils/ConstUtils";

export default createDefault([
  { value: 17, text: "Default" },
  { value: 16, text: "TodayInOut" },
]);
